module.exports = __webpack_public_path__ + "static/media/clear_birds.388a15db.mp3";